import { post } from '@/services/api'

export type TuitionCheckResponse = {
	notFound?: boolean
	isAdmitted?: boolean
	firstName?: string
	lastName?: string
}

export async function checkAdmission(email: string): Promise<TuitionCheckResponse> {
	const normalized = String(email ?? '')
		.trim()
		.toLowerCase()
	return post('/hubspot/check-status', { email: normalized })
}

export default { checkAdmission }
